import { useState } from 'react';
import { Calculator } from 'lucide-react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { laptopCleaningData } from '../mock';

export default function LaptopCleaningCalculator() {
  const [brand, setBrand] = useState('');
  const [modelIndex, setModelIndex] = useState('');
  const [price, setPrice] = useState(null);
  const models = brand ? laptopCleaningData.gaming[brand] : [];

  const calculate = () => {
    const selected = models[Number(modelIndex)];
    setPrice(selected ? Math.max(selected.price, 1500) : null);
  };

  return (
    <section className="px-4 py-14 md:py-20" data-testid="laptop-cleaning-calculator">
      <div className="container mx-auto max-w-3xl glass-card p-6 md:p-8">
        <h2 className="mb-6 text-3xl font-black text-white">Калькулятор ігрових ноутбуків</h2>
        <div className="grid gap-4">
          <Select value={brand} onValueChange={(value) => { setBrand(value); setModelIndex(''); setPrice(null); }}>
            <SelectTrigger data-testid="calculator-brand-select" className="calc-select border-cyan-400/30"><SelectValue placeholder="Оберіть виробника" /></SelectTrigger>
            <SelectContent>{Object.keys(laptopCleaningData.gaming).map((item) => <SelectItem key={item} value={item}>{item}</SelectItem>)}</SelectContent>
          </Select>
          {brand && <Select value={modelIndex} onValueChange={(value) => { setModelIndex(value); setPrice(null); }}>
            <SelectTrigger data-testid="calculator-model-select" className="calc-select border-cyan-400/30"><SelectValue placeholder="Оберіть модель" /></SelectTrigger>
            <SelectContent>{models.map((item, index) => <SelectItem key={`${item.model}-${index}`} value={String(index)}>{item.model}{models.filter((entry) => entry.model === item.model).length > 1 ? ` — варіант ${index + 1}` : ''}</SelectItem>)}</SelectContent>
          </Select>}
          <Button onClick={calculate} disabled={modelIndex === ''} data-testid="calculator-submit" className="bg-gradient-to-r from-cyan-400 to-blue-500 text-white hover:from-cyan-300 hover:to-blue-400"><Calculator className="mr-2 h-5 w-5" />Розрахувати вартість</Button>
        </div>
        {price != null && <div className="mt-6 text-center" data-testid="calculator-price"><p className="text-gray-300">Орієнтовна вартість чистки</p><p className="text-4xl font-black text-cyan-400">{price} грн</p><p className="mt-2 text-sm text-gray-400">Остаточну вартість майстер підтвердить після діагностики.</p></div>}
      </div>
    </section>
  );
}